module.exports = __webpack_public_path__ + "static/media/Inter-ExtraBoldItalic.0d568aac.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-ExtraBoldItalic.woff2
// module id = 686
// module chunks = 21